/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
import React from 'react'

export default function CriteriaDetail({ViewOffer,selectedCriteria}) {
    const {items} =ViewOffer
    const criteria = items.product_criterion[selectedCriteria]
    return (
        <>{ViewOffer.hasOwnProperty('items') && (
            <div className="px-3.5 py-5 sm:min-w-[80%] min-w-[100%]">
                <div className="flex sm:flex-nowrap flex-wrap -mx-2">
                    <div className="px-2 sm:min-w-[20%] min-w-[50%]">
                        <p className="font-semibold text-sm text-[#090406]">Minimum {`${criteria.is_quantity?'Quantity':'Value'}`} </p>
                        <p className="text-xs9 font-semibold text-[#555259] pt-0.5">{criteria.is_quantity?
                            criteria.MIN_QUANTITY:Number(criteria.MIN_VALUE).toLocaleString('en-IN', {
                                style: 'currency',
                                currency: 'INR',
                            })} {`${criteria.is_quantity?'':' '}`}</p>
                    </div>
                    <div className="px-2 sm:min-w-[20%] min-w-[40%]">
                        <p className="font-semibold text-sm text-[#090406]">Maximum {`${criteria.is_quantity?'Quantity':'Value'}`}</p>
                        <p className="text-xs9 font-semibold text-[#555259] pt-0.5"><>{criteria.is_quantity?
                            criteria.MAX_QUANTITY:Number(criteria.MAX_VALUE).toLocaleString('en-IN', {
                                style: 'currency',
                                currency: 'INR',
                            })}</> {`${criteria.is_quantity?'':''}`}</p>
                    </div>
                    <div className="px-2 sm:min-w-[20%] min-w-[40%] sm:mt-0 mt-3">
                        <p className="font-semibold text-sm text-[#090406]">Trade Discount</p>
                        <p className="text-xs9 font-semibold text-[#555259] pt-0.5">{criteria.discount_parameter==='0'?Number(criteria?.TRADE_DISCOUNT).toLocaleString('en-IN', {
                            style: 'currency',
                            currency: 'INR',
                        }):`${criteria?.TRADE_DISCOUNT}%`}</p>
                    </div>
                    <div className="px-2 sm:min-w-[20%] min-w-[40%] sm:mt-0 mt-3">
                        <p className="font-semibold text-sm text-[#090406]">Additional Discount</p>
                        <p className="text-xs9 font-semibold text-[#555259] pt-0.5">
                            {criteria.discount_parameter==='0'?Number(criteria?.ADDITIONAL_DISCOUNT).toLocaleString('en-IN', {
                                style: 'currency',
                                currency: 'INR',
                            }):`${criteria?.ADDITIONAL_DISCOUNT}%`}</p>
                    </div>
                    <div className="px-2 sm:min-w-[20%] min-w-[40%] sm:mt-0 mt-3">
                        <p className="font-semibold text-sm text-[#090406]">Maximum Discount</p>
                        <p className="text-xs9 font-semibold text-[#555259] pt-0.5">
                            {Number(criteria?.MAX_DISCOUNT).toLocaleString('en-IN', {
                                style: 'currency',
                                currency: 'INR',
                            })}</p>
                    </div>
                </div>
                <p className="font-semibold text-sm text-[#090406] pt-4">Products</p>
                <>
                    {items.product_criterion[selectedCriteria]?.product_parameters.map((val,i)=><p key={i} className="text-[#555259] font-semibold sm:text-lg text-sm">
                        {val.CATEGORY_CONCAT_SEGS.split('.').join('>')} </p>)}
                </>
                
                
            </div>
        )}</>
    )
}
